import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: `${process.env.NEXT_PUBLIC_WORDPRESS_URL && process.env.NEXT_PUBLIC_WORDPRESS_URL.endsWith('/') ? process.env.NEXT_PUBLIC_WORDPRESS_URL.substring(0, process.env.NEXT_PUBLIC_WORDPRESS_URL.length - 1) : process.env.NEXT_PUBLIC_WORDPRESS_URL}/graphql`,
  cache: new InMemoryCache(),
});

export default client;
